// remove team members from byBoard
export const reduceRemoveUsersFromBoard = (
  state,
  { payload: { boardId } },
) => ({
  ...state,
  byBoard: {
    ...state.byBoard,
    [boardId]: [],
  },
});
